<molla-accordion [adClass]="'accordion-plus product-details-accordion mb-2'" [id]="'product-accordion'">
    <molla-card [adClass]="'card-box card-sm bg-light'" [show]="false" [parent]="'product-accordion'"
        [title]="'Description'">
        <div id="product-accordion-desc">
            <div class="card-body">
                <div class="product-desc-content">
                    <h3><!--Product Information--></h3>
                    <p class="pb-1"></p>                    
                    
                </div>
            </div>
        </div>
    </molla-card>

    <molla-card [adClass]="'card-box card-sm bg-light'" [show]="false" [parent]="'product-accordion'"
        [title]="'Additional Information'">
        <div id="product-accordion-info">
            <div class="card-body">
                <div class="product-desc-content">
                    <h3><!--Information--></h3>                    
                </div>
            </div>
        </div>
    </molla-card>

    <molla-card [adClass]="'card-box card-sm bg-light'" [show]="true" [parent]="'product-accordion'"
        [title]="'Shipping & Returns'">
        <div id="product-accordion-shipping">
            <div class="card-body">
                <div class="product-desc-content">
                    <h3><!--Delivery & returns--></h3>                    
                </div>
            </div>
        </div>
    </molla-card>

    <molla-card [adClass]="'card-box card-sm bg-light'" [show]="false" [parent]="'product-accordion'"
        [title]="'Reviews (' + product.review + ')'">
        <div id="product-accordion-review">
            <div class="card-body">
                <div class="reviews">
                    <div class="review">
                        <div class="row no-gutters">
                            <div class="col-auto">
                                <h4><a href="javascript:;">Samanta J.</a></h4>
                                <div class="ratings-container">
                                    <div class="ratings">
                                        <div class="ratings-val" [style.width]="product.ratings * 20 + '%'"></div>
                                        <span class="tooltip-text">{{ product.ratings.toFixed(2) }}</span>
                                    </div>
                                </div>
                                <span class="review-date">6 days ago</span>
                            </div>
                            <div class="col">
                                <h4>Good, perfect size</h4>

                                <div class="review-content">
                                    <p></p>
                                </div>

                                <div class="review-action">
                                    <a href="javascript:;"><i class="icon-thumbs-up"></i>Helpful (2)</a>
                                    <a href="javascript:;"><i class="icon-thumbs-down"></i>Unhelpful (0)</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--
                <div class="reply">
                    <div class="title-wrapper text-left">
                        <h3 class="title title-simple text-left text-normal">Add a Review
                        </h3>
                        <p>Your email address will not be published. Required fields are
                            marked *</p>
                    </div>
                    <div class="rating-form">
                        <label for="rating" class="text-dark">Your rating * </label>
                        <span class="rating-stars selected">
                            <a [class]="'star-' + num " href="javascript:;" (click)="setRating($event)"
                                *ngFor="let num of [1,2,3,4,5]">{{ num }}</a>
                        </span>

                        <select name="rating" id="rating" required="" style="display: 'none'">
                            <option value="">Rate…</option>
                            <option value="5">Perfect</option>
                            <option value="4">Good</option>
                            <option value="3">Average</option>
                            <option value="2">Not that bad</option>
                            <option value="1">Very poor</option>
                        </select>
                    </div>
                    <form action="#">
                        <textarea id="reply-message" cols="30" rows="6" class="form-control mb-2"
                            placeholder="Comment *" required></textarea>
                        <div class="row">
                            <div class="col-md-6">
                                <input type="text" class="form-control" id="reply-name" name="reply-name"
                                    placeholder="Name *" required />
                            </div>
                            <div class="col-md-6">
                                <input type="email" class="form-control" id="reply-email" name="reply-email"
                                    placeholder="Email *" required />
                            </div>
                        </div>
                        <div class="form-checkbox d-flex align-items-start mb-2">
                            <input type="checkbox" class="custom-checkbox" id="signin-remember"
                                name="signin-remember" />
                            <label class="form-control-label ml-3" for="signin-remember">
                                Save my name, email, and website in this browser for the
                                next time I comment.
                            </label>
                        </div>
                        <button type="submit" class="btn btn-primary">Submit</button>
                    </form>
                </div>
                -->
            </div>
        </div>
    </molla-card>
</molla-accordion>